import { CreditScore } from '@/catalog/types';
import { AgeRange } from '@/catalog/types/age-range';
import Gauge from '@/icons/guage';
import Person from '@/icons/person';
import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';

export interface FilterCreditAgePillCopyProps {
  selectedCreditScoreId?: string;
  creditScores: CreditScore[];
  selectedAgeRangeId?: string;
  ageRanges?: AgeRange[];
  forceShorthandCopy?: boolean;
  dark?: boolean;
  ageRangePlaceholder?: string;
  creditScorePlaceholder?: string;
}

export default function FilterCreditAgePillCopy({
  creditScores,
  selectedCreditScoreId,
  selectedAgeRangeId,
  ageRanges,
  forceShorthandCopy,
  dark,
  ageRangePlaceholder,
  creditScorePlaceholder,
}: FilterCreditAgePillCopyProps) {
  const selectedCreditScore = creditScores.find(
    (score) => score.id === selectedCreditScoreId
  )?.range;
  const selectedAgeRange = ageRanges?.find((age) => age.id === selectedAgeRangeId);

  return (
    <>
      <Person
        fillPrimary={dark ? colors.neutral100 : colors.neutral1}
        className="inline-block h-[16px] w-[16px]"
      />{' '}
      <span
        className={cn({
          'hidden sm:inline': !forceShorthandCopy,
          'hidden': forceShorthandCopy,
        })}
      >
        Age:
      </span>{' '}
      {selectedAgeRange?.display_name ?? ageRangePlaceholder ?? ''}{' '}
      {ageRanges && ageRanges?.length > 0 ? (
        <>
          <span className="text-flexcar-neutral1/20">|</span>
          <Gauge
            fillPrimary={dark ? colors.neutral100 : colors.neutral1}
            className="inline-block h-[16px] w-[16px]"
          />{' '}
          <span
            className={cn({
              'hidden sm:inline': !forceShorthandCopy,
              'hidden': forceShorthandCopy,
            })}
          >
            Credit:
          </span>{' '}
          {selectedCreditScore ?? creditScorePlaceholder ?? ''}
        </>
      ) : null}
    </>
  );
}
